$('html').on('click', '.faq-question', function() {
    const answer = $(this).next('.faq-answer');
    answer.slideToggle('slow');
    answer.toggleClass('open')
});